// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-12a11480] #editorReviewFeedback .ql-editor{min-height:20rem!important;word-break:break-word}[data-v-12a11480] #editorReviewFeedback .ql-editor p{margin-bottom:1rem!important}[data-v-12a11480] #inputAttachments .dz-default.dz-message{display:none!important}", ""]);
// Exports
module.exports = exports;
